import React from "react";
import { useNavigate } from "react-router-dom";
import "./GroupCaptive.css";
import gcHeroImg from "../../assets/GCsection1.png";
import gcThumbImg from "../../assets/GCsection1-thumb.png";
import gcSPVImg from "../../assets/groupcaptive-3.png";
import gcIcon1 from "../../assets/GCsection4-icon1.png";
import gcIcon2 from "../../assets/GCsection4-icon2.png";
import gcIcon3 from "../../assets/GCsection4-icon3.png";
import gcIcon4 from "../../assets/GCsection4-icon4.png";
import gcBenefitsImg from "../../assets/GCsection5.png";
import gcFinancial1 from "../../assets/groupcaptive financial-1.png";
import gcFinancial2 from "../../assets/groupcaptive financial-2.png";
import gcFinancial3 from "../../assets/groupcaptive financial-3.png";
import gcFinancial4 from "../../assets/groupcaptive-finance-4.png";
import gcFinancial5 from "../../assets/groupcaptive financial-5.png";
import IconManufacturers from "../../assets/Manufacturers.png";
import IconPharma from "../../assets/Pharma.png";
import IconCorporate from "../../assets/Corporate.png";
import IconITPark from "../../assets/IT.png";
import IconDataCenter from "../../assets/Data.png";
import IconCommercial from "../../assets/Commercial.png";
import IconWarehouse from "../../assets/Warehouse.png";
import IconAutomotive from "../../assets/Automotive.png";
import IconSteel from "../../assets/Steel.png";
import IconHospitality from "../../assets/Hospital.png";
import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import gcs1step1 from "../../assets/gcs1step1.png";
import gcs1step2 from "../../assets/gcs1step2.png";
import gcs1step3 from "../../assets/gcs1step3.png";
import gcs1step4 from "../../assets/gcs1step4.png";
import gcs1step5 from "../../assets/gcs1step5.png";
import gcs1step6 from "../../assets/gcs1step6.png";
import gcs2step1 from "../../assets/gcs2step1.png";
import gcs2step2 from "../../assets/gcs2step2.png";
import gcs2step3 from "../../assets/gcs2step3.png";
import gcs2step4 from "../../assets/gcs2step4.png";
import gcs2step5 from "../../assets/gcs2step5.png";
import gcs2step6 from "../../assets/gcs2step6.png";
import gcs2step7 from "../../assets/gcs2step7.png";
import gcs3step1 from "../../assets/gcs3step1.png";
import gcs3step2 from "../../assets/gcs3step2.png";
import gcs3step3 from "../../assets/gcs3step3.png";
import gcs3step4 from "../../assets/gcs3step4.png";
import gcs3step5 from "../../assets/gcs3step5.png";
import gcs3step6 from "../../assets/gcs3step6.png";
import gcs4step1 from "../../assets/gcs4step1.png";
import gcs4step2 from "../../assets/gcs4step2.png";
import gcs4step3 from "../../assets/gcs4step3.png";
import gcs4step4 from "../../assets/gcs4step4.png";
import gcs4step5 from "../../assets/gcs4step5.png";
import gcs4step6 from "../../assets/gcs4step6.png";
import gcs5step1 from "../../assets/gcs5step1.png";
import gcs5step2 from "../../assets/gcs5step2.png";
import gcs5step3 from "../../assets/gcs5step3.png";
import gcs5step4 from "../../assets/gcs5step4.png";
import gcs5step5 from "../../assets/gcs5step5.png";
import gcs5step6 from "../../assets/gcs5step6.png";
import gcs5step7 from "../../assets/gcs5step7.png";
import gcs6step1 from "../../assets/gcs6step1.png";
import gcs6step2 from "../../assets/gcs6step2.png";
import gcs6step3 from "../../assets/gcs6step3.png";
import gcs6step4 from "../../assets/gcs6step4.png";
import gcs6step5 from "../../assets/gcs6step5.png";
import gcs6step6 from "../../assets/gcs6step6.png";
import gcs6step7 from "../../assets/gcs6step7.png";
import gcs7step1 from "../../assets/gcs7step1.png";
import gcs7step2 from "../../assets/gcs7step2.png";
import gcs7step3 from "../../assets/gcs7step3.png";
import gcs7step4 from "../../assets/gcs7step4.png";
import gcs7step5 from "../../assets/gcs7step5.png";
import gcs7step6 from "../../assets/gcs7step6.png";
import gcs7step7 from "../../assets/gcs7step7.png";
import gcs7step8 from "../../assets/gcs7step8.png";
import gcs8step1 from "../../assets/gcs8step1.png";
import gcs8step2 from "../../assets/gcs8step2.png";
import gcs8step3 from "../../assets/gcs8step3.png";
import gcs8step4 from "../../assets/gcs8step4.png";
import gcs8step5 from "../../assets/gcs8step5.png";
import gcs8step6 from "../../assets/gcs8step6.png";
import gcs8step7 from "../../assets/gcs8step7.png";
import gcs9step1 from "../../assets/gcs9step1.png";
import gcs9step2 from "../../assets/gcs9step2.png";
import gcs9step3 from "../../assets/gcs9step3.png";
import gcs9step4 from "../../assets/gcs9step4.png";
import gcs9step5 from "../../assets/gcs9step5.png";
import gcs9step6 from "../../assets/gcs9step6.png";
import gcs9step7 from "../../assets/gcs9step7.png";
import gcs10step1 from "../../assets/gcs10step1.png";
import gcs10step2 from "../../assets/gcs10step2.png";
import gcs10step3 from "../../assets/gcs10step3.png";
import gcs10step4 from "../../assets/gcs10step4.png";
import gcs10step5 from "../../assets/gcs10step5.png";
import gcs10step6 from "../../assets/gcs10step6.png";
import gcs10step7 from "../../assets/gcs10step7.png";
import gcs11step1 from "../../assets/gcs11step1.png";
import gcs11step2 from "../../assets/gcs11step2.png";
import gcs11step3 from "../../assets/gcs11step3.png";
import gcs11step4 from "../../assets/gcs11step4.png";
import gcs11step5 from "../../assets/gcs11step5.png";
import gcs11step6 from "../../assets/gcs11step6.png";
import gcs11step7 from "../../assets/gcs11step7.png";
import gcs11step8 from "../../assets/gcs11step8.png";
import gcs12step1 from "../../assets/gcs12step1.png";
import gcs12step2 from "../../assets/gcs12step2.png";
import gcs12step3 from "../../assets/gcs12step3.png";
import gcs12step4 from "../../assets/gcs12step4.png";
import gcs12step5 from "../../assets/gcs12step5.png";
import gcs12step6 from "../../assets/gcs12step6.png";
import gcs12step7 from "../../assets/gcs12step7.png";
import gcWhyImg from "../../assets/groupcaptive-why choose.png";
import gcProj1 from "../../assets/CIRsection6-1.png";
import gcProj2 from "../../assets/CIRsection6-2.png";
// import Testi1 from "../../assets/testi1.png";
// import Testi2 from "../../assets/testi2.png";
// import Testi3 from "../../assets/testi3.png";
import { useRef, useEffect,useState } from "react";
const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };
    window.addEventListener("scroll", check);
  }, []);
  return ref;
};

/* ================================================
   SECTION 1 — HERO
   ================================================ */
const GroupCaptiveHero = () => {
  const navigate = useNavigate();
  return (
  <section className="gc-hero">
    {/* ── Left text content ── */}
    <div className="gc-hero-content">
      <h1 className="gc-hero-title">
        Shared Ownership.
        <br />
        Shared Savings.
        <br />
        Maximum Flexibility
      </h1>
      <div className="gc-hero-body">
        <p className="gc-hero-desc">
          Co-own solar assets and access power at lower tariffs through a
          structured Group Captive model. True Renewables manage SPV formation,
          compliance, execution, and long-term operations end-to-end.
        </p>
        <button className="gc-hero-btn" onClick={() => navigate("/contact")}>Book A Free Call</button>
      </div>
    </div>

    {/* ── Thumbnail — bottom left ── */}
    <div className="gc-hero-thumb">
      <img
        src={gcThumbImg}
        alt="Solar installation"
        className="gc-hero-thumb-img"
      />
    </div>

    {/* ── Orange accent block — sits behind the main image ── */}
    <div className="gc-hero-orange-accent" />

    {/* ── Main right image ── */}
    <div className="gc-hero-img-wrap">
      <img src={gcHeroImg} alt="Group Captive Solar" className="gc-hero-img" loading="lazy" />
    </div>
  </section>
  );
};

/* ================================================
   SECTION 2 — OVERVIEW
   ================================================ */
const GroupCaptiveOverview = () => {
  const sectionRef = useRef(null);
  const wordRefs = useRef([]);

  const darkText =
    "The Group Captive Model allows multiple commercial and industrial (C&I) consumers to co-own a solar power plant ";
  const lightText =
    "and collectively offtake power at significantly lower tariffs than DISCOM supply.";

  const allWords = [
    ...darkText.split(" ").map((w) => ({ word: w, type: "dark" })),
    ...lightText.split(" ").map((w) => ({ word: w, type: "light" })),
  ];

  useEffect(() => {
    const onScroll = () => {
      const el = sectionRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const windowH = window.innerHeight;

      const progress = Math.min(
        Math.max((windowH - rect.top) / (windowH + rect.height), 0),
        1,
      );

      const totalWords = wordRefs.current.length;
      const revealCount = Math.floor(progress * totalWords * 1.6);

      wordRefs.current.forEach((el, i) => {
        if (!el) return;
        el.style.color = i < revealCount ? "#111111" : "#6B6B6B";
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="gc-overview" ref={sectionRef}>
      <div className="gc-overview-content">
        <p className="gc-overview-tag">
          <span className="gc-overview-dot" />
          OVERVIEW
        </p>
        <p className="gc-overview-text">
          {allWords.map((item, i) => (
            <span
              key={i}
              ref={(el) => (wordRefs.current[i] = el)}
              style={{ color: "#6B6B6B", transition: "color 0.3s ease" }}
            >
              {item.word}
              {i < allWords.length - 1 ? " " : ""}
            </span>
          ))}
        </p>
      </div>
    </section>
  );
};
/* ================================================
   SECTION 3 — SPV CARD
   ================================================ */
const GroupCaptiveSPV = () => {
  const checkItems = [
    "Consumers together hold minimum 26% equity.",
    "Consume minimum 51% of the power generated annually",
  ];

  return (
    <section className="gc-spv">
      <div className="gc-spv-inner">
        {/* ── Left text card ── */}
        <div className="gc-spv-card">
          <h3 className="gc-spv-card-heading">
            A Group Captive project is developed through a Special Purpose
            Vehicle (SPV) where:
          </h3>

          <ul className="gc-spv-checklist">
            {checkItems.map((item, i) => (
              <li key={i} className="gc-spv-check-item">
                <svg
                  className="gc-spv-check-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 12.5L9.5 18L20 7"
                    stroke="#C04820"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {item}
              </li>
            ))}
          </ul>

          <p className="gc-spv-uppercase-text">
            This allows partial ownership for each consumer while unlocking open
            access benefits, reduced tariffs, and long-term price stability.
          </p>

          <p className="gc-spv-bottom-text">
            It is one of the most cost-efficient energy models for companies
            that want clean power without full plant ownership.
          </p>
        </div>

        {/* ── Right image ── */}
        <div className="gc-spv-img-wrap">
          <img
            src={gcSPVImg}
            alt="Solar plant engineers"
            className="gc-spv-img"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 4 — REGULATORY COMPLIANCE
   ================================================ */
const GroupCaptiveCompliance = () => {
  const cards = [
    {
      icon: gcIcon1,
      title: "Equity Ownership",
      desc: "Collective consumer equity: ≥ 26%",
    },
    {
      icon: gcIcon2,
      title: "Power Consumption",
      desc: "Collective consumption: ≥ 51% of plant generation",
    },
    {
      icon: gcIcon3,
      title: "Proportionate Equity",
      desc: "Equity holding must be in proportion to consumption",
    },
    {
      icon: gcIcon4,
      title: "Open Access Framework",
      desc: "Power is supplied through state open access regulations",
    },
  ];

  return (
    <section className="gc-compliance">
      <div className="gc-compliance-inner">
        {/* ── Left column ── */}
        <div className="gc-compliance-left">
          <div className="gc-compliance-text-top">
            <p className="gc-compliance-tag">
              <span className="gc-compliance-dot" />
              GROUP CAPTIVE COMPLIANCE
            </p>
            <h2 className="gc-compliance-title">
              Regulatory Criteria For Group Captive Qualification
            </h2>
          </div>
          <p className="gc-compliance-footer-text">
            True Renewables manages all statutory, legal, and compliance
            requirements from start to finish
          </p>
        </div>

        {/* ── Right 2×2 grid ── */}
        <div className="gc-compliance-grid">
          {cards.map((card, i) => (
            <div key={i} className="gc-compliance-card">
              <div className="gc-compliance-icon-wrap">
                <img
                  src={card.icon}
                  alt={card.title}
                  className="gc-compliance-icon-img"
                  loading="lazy"
                />
              </div>
              <p className="gc-compliance-card-title">{card.title}</p>
              <p className="gc-compliance-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 5 — FINANCIAL BENEFITS
   ================================================ */
const gcBenefitItems = [
  {
    title: "Deep savings compared to grid power",
    desc: "Landed cost can be 35–55% lower depending on the state.",
    image: gcFinancial1,
  },
  {
    title: "Low equity investment",
    desc: "Multiple consumers share equity and reduce individual burden.",
    image: gcFinancial2,
  },
  {
    title: "Price stability for 25 years",
    desc: "No tariff shocks, no year-on-year escalations.",
    image: gcFinancial3,
  },
  {
    title: "Strong ROI",
    desc: "Investor IRR typically ranges from 14–20%.",
    image: gcFinancial4,
  },
  {
    title: "Ideal for multi-location or mid-size industries",
    desc: "Even consumers with limited consumption can participate.",
    image: gcFinancial5,
  },
];

const GroupCaptiveBenefits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const outerRef = useRef(null);
  const activeIndexRef = useRef(0);

  /* ── Pin the panel while scrolling through the outer (tall) wrapper,
     driving activeIndex from scroll progress. ── */
  useEffect(() => {
    let raf;

    const update = () => {
      const el = outerRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const totalScroll = el.offsetHeight - window.innerHeight;
        const scrolled = -rect.top;
        const p =
          totalScroll > 0
            ? Math.max(0, Math.min(scrolled / totalScroll, 1))
            : 0;

        const idx = Math.min(
          gcBenefitItems.length - 1,
          Math.floor(p * gcBenefitItems.length)
        );

        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const timer = setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="gc-benefits-outer"
      ref={outerRef}
      style={{ height: `${gcBenefitItems.length * 110}vh` }}
    >
      <section className="gc-benefits-sticky">
        <div className="gc-benefits">
          {/* ── Centered header ── */}
          <div className="gc-benefits-header">
            <p className="gc-benefits-tag">
              <span className="gc-benefits-dot" />
              FINANCIAL BENEFITS
            </p>
            <h2 className="gc-benefits-title">
              Driven By Returns. Backed By Structure.
            </h2>
          </div>

          {/* ── Body: list left + image right ── */}
          <div className="gc-benefits-body">
            {/* Left benefit items */}
            <div className="gc-benefits-list">
              {gcBenefitItems.map((item, i) => (
                <div key={i}>
                  <div
                    className={`gc-benefit-item ${
                      i === activeIndex ? "gc-benefit-item--active" : ""
                    }`}
                    onClick={() => setActiveIndex(i)}
                    onMouseEnter={() => setActiveIndex(i)}
                  >
                    {/* Orange bar — only for active */}
                    {i === activeIndex && <span className="gc-benefit-bar" />}

                    <div className="gc-benefit-text">
                      <p className="gc-benefit-title">{item.title}</p>

                      {/* Desc — only for active, animates in */}
                      {i === activeIndex && (
                        <p className="gc-benefit-desc">{item.desc}</p>
                      )}
                    </div>
                  </div>

                  {/* Mobile-only inline image — appears below the active item */}
                  <div className="gc-benefit-mobile-img-wrap">
                    <div className="gc-benefit-mobile-img-bg" />
                    <img
                      src={item.image}
                      alt={item.title}
                      className="gc-benefit-mobile-img"
                      loading="lazy"
                    />
                  </div>

                  {i < gcBenefitItems.length - 1 && (
                    <hr className="gc-benefit-divider" />
                  )}
                </div>
              ))}
            </div>

            {/* Right image with blue offset block */}
            <div className="gc-benefits-img-wrap">
              <div className="gc-benefits-img-bg" />
              <img
                src={gcBenefitItems[activeIndex].image}
                alt={gcBenefitItems[activeIndex].title}
                className="gc-benefits-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
/* ================================================
   SECTION — WHO IT'S FOR (CAPTIVE)
   ================================================ */

const WHO_ITEMS = [
  { label: "Manufacturers", icon: IconManufacturers },
  { label: "Pharma", icon: IconPharma },
  { label: "Corporate Groups", icon: IconCorporate },
  { label: "IT Parks", icon: IconITPark },
  { label: "Data Centers", icon: IconDataCenter },
  { label: "Large Commercial Consumers", icon: IconCommercial },
  { label: "Warehousing & Logistics", icon: IconWarehouse },
  { label: "Automotive", icon: IconAutomotive },
  { label: "Steel & Fabrication", icon: IconSteel },
  { label: "Hospitality Chains", icon: IconHospitality },
];

const CaptiveWhoItsFor = () => {
  // split items into 2 rows
  const topRow = WHO_ITEMS.slice(0, 5);
  const bottomRow = WHO_ITEMS.slice(5);

  // duplicate for seamless loop
  const topTicker = [...topRow, ...topRow, ...topRow, ...topRow];
  const bottomTicker = [...bottomRow, ...bottomRow, ...bottomRow, ...bottomRow];

  return (
    <section className="captive-who-section">
      {/* Header */}
      <div className="captive-who-header">
        <p className="captive-who-tag">
          <span className="captive-who-dot" />
          WHO IT'S FOR
        </p>

        <h2 className="captive-who-title">
          Ideal for Collaborative Energy Models
        </h2>

        <p className="captive-who-subtitle">
          Best suited for businesses seeking lower tariffs through shared solar
          ownership.
        </p>
      </div>

      {/* Ticker */}
      <div className="captive-who-ticker">
        <div className="captive-who-track">
          {/* 🔹 TOP ROW → RIGHT */}
          <div className="captive-who-row captive-who-row-top">
            {topTicker.map((item, i) => (
              <div className="captive-who-card" key={`top-${i}`}>
                <img
                  src={item.icon}
                  alt={item.label}
                  className="captive-who-card-icon"
                  loading="lazy"
                />
                <p className="captive-who-card-label">{item.label}</p>
              </div>
            ))}
          </div>

          {/* 🔹 BOTTOM ROW → LEFT */}
          <div className="captive-who-row captive-who-row-bottom">
            {bottomTicker.map((item, i) => (
              <div className="captive-who-card" key={`bottom-${i}`}>
                <img
                  src={item.icon}
                  alt={item.label}
                  className="captive-who-card-icon"
                  loading="lazy"
                />
                <p className="captive-who-card-label">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 7 — HOW IT WORKS
   ================================================ */
const gcStages = [
  {
    id: 1,
    title: "Demand & Feasibility",
    steps: [
      { title: "Consolidated annual consumption study for all participating consumers" , image: gcs1step1},
      { title: "Load profile mapping (HT feeders, shift patterns, peak hours)" , image: gcs1step2},
      { title: "Allocation plan for consumption ratio among members" , image: gcs1step3},
      { title: "Group Captive vs Captive vs OA suitability check" , image: gcs1step4},
      { title: "Initial plant sizing based on total aggregate demand" , image: gcs1step5},
      { title: "Evacuation feasibility & OA viability" , image: gcs1step6},
    ],
  },
  {
    id: 2,
    title: "Financial & Equity Model",
    steps: [
      { title: "25-year landed cost comparison vs grid tariff" , image: gcs2step1},
      { title: "Savings model per consumer" , image: gcs2step2},
      { title: "IRR and ROI modelling per investor/shareholder" , image: gcs2step3},
      { title: "Equity distribution based on consumption share" , image: gcs2step4},
      { title: "Establishing 26% equity + 51% consumption compliance for all members" , image: gcs2step5},
      { title: "Forecasting returns for each consumer-investor" , image: gcs2step6},
      { title: "Sensitivity modelling for tariff change & OA charge variations" , image: gcs2step7},
    ],
  },
  {
    id: 3,
    title: "Land & Evacuation",
    steps: [
      { title: "Land procurement / leasing support" , image: gcs3step1},
      { title: "Due diligence, conversion, and right-of-way checks" , image: gcs3step2},
      { title: "Substation loading capacity & bay availability" , image: gcs3step3},
      { title: "Evacuation route design (HT line, ROW corridor, safety compliance)" , image: gcs3step4},
      { title: "Soil testing, contouring, storm water planning" , image: gcs3step5},
      { title: "Preliminary SCADA & grid protection scope" , image: gcs3step6},
    ],
  },
  {
    id: 4,
    title: "SPV & Legal Setup",
    steps: [
      { title: "SPV incorporation for group captive ownership" , image: gcs4step1},
      { title: "Shareholding agreements for each investor" , image: gcs4step2},
      { title: "Equity proportioning based on consumption share" , image: gcs4step3},
      { title: "Compliance documentation as per state regulations" , image: gcs4step4},
      { title: "Power Delivery Agreements (PDA) & subscription agreements" , image: gcs4step5},
      { title: "Corporate governance & investor rights framework" , image: gcs4step6},
    ],
  },
  {
    id: 5,
    title: "Regulatory Approvals",
    steps: [
      { title: "DISCOM NOC for each participating consumer" , image: gcs5step1},
      { title: "SLDC approval for scheduling & forecasting" , image: gcs5step2},
      { title: "CEIG/CEA compliance preparation" , image: gcs5step3},
      { title: "Open Access application (annual, monthly, STOA/LTOA based on model)" , image: gcs5step4},
      { title: "Banking & wheeling rule mapping per consumer" , image: gcs5step5},
      { title: "Approval tracker inside TrueTrack™" , image: gcs5step6},
      { title: "Automated alerts for pending actions across stakeholders" , image: gcs5step7},
    ],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    steps: [
      { title: "Final SLD, layouts, inverter/transformer sizing" , image: gcs6step1},
      { title: "Multi-bay evacuation planning for large capacities" , image: gcs6step2},
      { title: "SCADA network design with individual consumer data segregation" , image: gcs6step3},
      { title: "Vendor locking for modules, inverters, transformers, MMS" , image: gcs6step4},
      { title: "Detailed BOQ with procurement timelines" , image: gcs6step5},
      { title: "Logistics & storage planning" , image: gcs6step6},
      { title: "Digital QA documentation" , image: gcs6step7},
    ],
  },
  {
    id: 7,
    title: "EPC Execution",
    steps: [
      { title: "Daily construction logs: civil, MMS, DC, AC progress" , image: gcs7step1},
      { title: "Milestone completion tracking (planned vs actual)" , image: gcs7step2},
      { title: "Automated delay alerts" , image: gcs7step3},
      { title: "Manpower & machinery deployment logs" , image: gcs7step4},
      { title: "Material arrival, inspection & consumption" , image: gcs7step5},
      { title: "Live photos, videos, drone captures" , image: gcs7step6},
      { title: "Client dashboard with access for each consumer-investor" , image: gcs7step7},
      { title: "Transparent EPC progress for multi-stakeholder trust" , image: gcs7step8},
    ],
  },
  {
    id: 8,
    title: "Testing & Sync",
    steps: [
      { title: "ABT meters installation & sealing" , image: gcs8step1},
      { title: "CT/PT testing & accuracy checks" , image: gcs8step2},
      { title: "Synchronisation with grid" , image: gcs8step3},
      { title: "Trial runs & stability testing" , image: gcs8step4},
      { title: "SCADA integration with user dashboards" , image: gcs8step5},
      { title: "CEIG approvals & final energization" , image: gcs8step6},
      { title: "Baseline performance benchmarking for O&M handover" , image: gcs8step7},
    ],
  },
  {
    id: 9,
    title: "Live Monitoring",
    steps: [
      { title: "24/7 SCADA-based plant monitoring" , image: gcs9step1},
      { title: "PR, CUF, inverter-level performance" , image: gcs9step2},
      { title: "Feeder-wise & consumer-wise energy allocation" , image: gcs9step3},
      { title: "Forecast vs actual generation analytics" , image: gcs9step4},
      { title: "AI-driven alerts: string drops, inverter issues, soiling loss, temperature anomalies" , image: gcs9step5},
      { title: "Weather-adjusted modelling & degradation insights" , image: gcs9step6},
      {
        title: "Dual dashboards:" , image: gcs9step7,
        bullets: [
          "Engineering dashboard for technical depth",
          "Consumer dashboard for simple consumption & savings",
        ],
      },
    ],
  },
  {
    id: 10,
    title: "O&M and Health",
    steps: [
      { title: "Preventive maintenance planner(cleaning,tightening,thermography)" , image: gcs10step1},
      { title: "Corrective maintenance ticketing with SLA escalation" , image: gcs10step2},
      { title: "Drone-based thermography scans for hotspot diagnosis" , image: gcs10step3},
      { title: "Substation & evacuation line health checks" , image: gcs10step4},
      { title: "Availability & downtime reporting" , image: gcs10step5},
      { title: "Monthly performance health reports" , image: gcs10step6},
      { title: "Root cause analysis & improvement recommendations" , image: gcs10step7},
    ],
  },
  {
    id: 11,
    title: "Billing & Compliance",
    steps: [
      { title: "Automated monthly billing for each captive consumer" , image: gcs11step1},
      { title: "OA charge reconciliation: wheeling, banking, CSS, STU charges" , image: gcs11step2},
      { title: "ABT meter data import & settlement statements" , image: gcs11step3},
      { title: "Ensuring 51% mandatory consumption compliance for the group" , image: gcs11step4},
      { title: "Automated alerts for under-consumption by any member " , image: gcs11step5},
      { title: "Payment reminders, invoice distribution & digital receipts" , image: gcs11step6},
      { title: "Multi-consumer financial transparency" , image: gcs11step7},
      { title: "Compliance archive for regulators & auditors" , image: gcs11step8},
    ],
  },
  {
    id: 12,
    title: "Lifecycle Reporting",
    steps: [
      { title: "Investor dashboards with ROI, IRR, payback updates" , image: gcs12step1},
      { title: "Equity-linked performance insights" , image: gcs12step2},
      { title: "Multi-site portfolio consolidation" , image: gcs12step3},
      { title: "Carbon credit eligibility (REC/I-REC/VER)" , image: gcs12step4},
      { title: "Annual audited performance reports" , image: gcs12step5},
      { title: "Long-term asset optimization strategies" , image: gcs12step6},
      { title: "Data-ready outputs for CFOs, sustainability teams & auditors" , image: gcs12step7},
    ],
  },
];

const GC_N = gcStages.length;
const GC_RADIUS = 380;
const GC_ANGLE_STEP = 30;
const GC_MINOR_TICKS = 72;

const GroupCaptiveHowItWorks = () => {
  const sectionRef = useRef(null);
  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);
  const activeStageRef = useRef(0);
  const logoRef = useRef(null);

  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".gc-hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const startDelay = headerHeight + window.innerHeight * 0.2;
      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;
      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * GC_N;
      const activeFloat = Math.min(arcFloat, GC_N - 1);
      const activeIndex = Math.round(activeFloat);
      const currentRotation = -(activeFloat * GC_ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current) {
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      }
      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      gcStages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;
        const dist = activeFloat - i;
        let opacity = 1;
        if (Math.abs(dist) < 0.5) opacity = 0;
        else if (dist > 0.5) opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        else if (dist < -5) opacity = 0;
        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1;
        itemEl.style.opacity = opacity;
        numEl.style.transform = `rotate(${-(i * GC_ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      if (arcRef.current) {
        const progress = Math.max(0, Math.min(arcFloat, GC_N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex);
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = gcStages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");
  const cardsData = currentStage.steps;

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      const scrollAmount = cardsContainerRef.current.offsetWidth;
      cardsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="gc-hiw-outer"
      ref={sectionRef}
      style={{ height: `${gcStages.length * 110}vh` }}
    >
      <div className="gc-hiw-header-wrap">
        <div className="gc-hiw-tag">
          <span className="gc-hiw-dot"></span>
          HOW IT WORKS
        </div>
        <h2 className="gc-hiw-title">
          True 360° Execution —<br />
          Zero-Stress, End-to-End Solar
        </h2>
        <p className="gc-hiw-subtitle">
          A transparent, predictable, 12-stage execution framework that ensures
          every group captive solar project is delivered with absolute clarity and control.
        </p>
      </div>

      <div className="gc-hiw-sticky">
        <div className="gc-hiw-split">
          <div className="gc-hiw-left">
            <div className="gc-hiw-mobile-header">
              <div className="gc-hiw-tag">
                <span className="gc-hiw-dot"></span>
                HOW IT WORKS
              </div>
              <h2 className="gc-hiw-title">
                True 360° Execution —<br />
                Zero-Stress, End-to-End Solar
              </h2>
              <p className="gc-hiw-subtitle">
                A transparent, predictable, 12-stage execution framework that
                ensures every group captive solar project is delivered with absolute
                clarity and control.
              </p>
            </div>

            <div className="gc-hiw-dial-wrapper">
              <div className="gc-hiw-dial-container" ref={dialRef}>
                <div className="gc-hiw-dial-bg"></div>
                <div className="gc-hiw-dial-inner-orange"></div>

                {Array.from({ length: GC_MINOR_TICKS }).map((_, i) => (
                  <div
                    key={`tick-${i}`}
                    className="gc-hiw-dial-tick-min"
                    style={{
                      transform: `rotate(${i * (360 / GC_MINOR_TICKS)}deg) translate(${GC_RADIUS}px)`,
                    }}
                  />
                ))}

                <svg
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "678px",
                    height: "678px",
                    pointerEvents: "none",
                    zIndex: 2,
                  }}
                >
                  <circle
                    ref={arcRef}
                    cx="339"
                    cy="339"
                    r="333"
                    fill="none"
                    stroke="#F05A28"
                    strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333}
                    strokeDashoffset={2 * Math.PI * 333}
                    strokeLinecap="round"
                  />
                </svg>

                {gcStages.map((stage, i) => {
                  const itemAngle = i * GC_ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;
                  return (
                    <React.Fragment key={stage.id}>
                      <div
                        className={`gc-hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${GC_RADIUS}px)` }}
                      />
                      <div
                        className={`gc-hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${GC_RADIUS + 40}px)` }}
                      >
                        <div
                          className="gc-hiw-dial-num"
                          ref={(el) => (numRefs.current[i] = el)}
                          style={{ transform: "rotate(-90deg)" }}
                        >
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              <div className="gc-hiw-dial-inner">
                <img
                  src={trueRenewablesLogo}
                  alt="True Renewables"
                  className="gc-hiw-center-logo"
                  ref={logoRef}
                  loading="lazy"
                />
                <div className="gc-hiw-dial-pointer"></div>
              </div>

              <div className="gc-hiw-active-overlay">
                <div className="gc-hiw-inner-faint-line"></div>
                <div className="gc-hiw-active-thick-line"></div>
                <div className="gc-hiw-active-dot"></div>
                <div className="gc-hiw-active-text-block">
                  <span className="gc-hiw-active-num">{numStr}</span>
                  <span className="gc-hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>

            <div className="gc-hiw-mobile-info">
              <div className="gc-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="gc-hiw-mobile-title">{currentStage.title}</h3>
              <p className="gc-hiw-mobile-desc">
                {currentStage.steps.map((s) => s.title).join(", ")}
              </p>
              <button className="gc-hiw-mobile-view-btn" onClick={() => setIsMobilePopupOpen(true)}>
                VIEW DETAILS ↗
              </button>
            </div>
          </div>

          <div className={`gc-hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}>
            <div className="gc-hiw-popup-bg" onClick={() => setIsMobilePopupOpen(false)}></div>
            <div className="gc-hiw-popup-inner">
              <button className="gc-hiw-popup-close" onClick={() => setIsMobilePopupOpen(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div className="gc-hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="gc-hiw-right-title">{currentStage.title}</h2>

              <div className="gc-hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="gc-hiw-step-card">
                    <div className="gc-hiw-step-img-wrap">
                      <img
                       src={step.image}
                        alt={step.title}
                        className="gc-hiw-step-img"
                        loading="lazy"
                      />
                    </div>
                    <div className="gc-hiw-step-text">
                      <p className="gc-hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="gc-hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="gc-hiw-step-bullets">
                          {step.bullets.map((bullet, i) => (
                            <li key={i} className="gc-hiw-step-bullet">{bullet}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="gc-hiw-nav-arrows">
                <button type="button" className="gc-hiw-nav-arrow" onClick={() => scrollCards("left")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <button type="button" className="gc-hiw-nav-arrow" onClick={() => scrollCards("right")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>

              <div className="gc-hiw-popup-mobile-info">
                <div className="gc-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
                <h3 className="gc-hiw-mobile-title">{currentStage.title}</h3>
                <p className="gc-hiw-mobile-desc">
                  {currentStage.steps.map((s) => s.title).join(", ")}
                </p>
                <button className="gc-hiw-mobile-view-btn popup-btn" onClick={() => setIsMobilePopupOpen(false)}>
                  VIEW DETAILS ↗
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================================================
   SECTION 8 — WHY CHOOSE US
   ================================================ */
const GroupCaptiveWhyChooseUs = () => {
  const leftCards = [
    { num: "01", text: "Expertise in multi-consumer SPV structuring" },
    {
      num: "02",
      text: "Strong understanding of regulatory and open access frameworks",
    },
    {
      num: "03",
      text: "Proven execution capability across MW-scale C&I projects",
    },
  ];
  const rightCards = [
    { num: "04", text: "Transparent communication across all stakeholders" },
    { num: "05", text: "Robust engineering & premium procurement standards" },
    {
      num: "06",
      text: "25-year lifecycle support with full digital traceability",
    },
  ];

  return (
    <section className="gc-why">
      <div className="gc-why-header">
        <p className="gc-why-tag">
          <span className="gc-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="gc-why-title">
          End-To-End Group
          <br />
          Captive Excellence
        </h2>
      </div>

      <div className="gc-why-body">
        <div className="gc-why-col">
          {leftCards.map((c) => (
            <div className="gc-why-card" key={c.num}>
              <p className="gc-why-num">{c.num}</p>
              <p className="gc-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="gc-why-img-wrap">
          <img src={gcWhyImg} alt="Why Choose Us" className="gc-why-img" loading="lazy" />
        </div>

        <div className="gc-why-col">
          {rightCards.map((c) => (
            <div className="gc-why-card" key={c.num}>
              <p className="gc-why-num">{c.num}</p>
              <p className="gc-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 9 — FEATURED PROJECTS
   ================================================ */
const GroupCaptiveFeaturedProjects = () => {
  const projects = [
    {
      img: gcProj1,
      title: "Multi-Industry Group Captive Solar Plant",
      desc: "A 12 MW group captive solar project structured for five manufacturing companies, enabling collective ownership.",
      tags: ["KARNATAKA", "12 MW", "MULTI-CONSUMER"],
    },
    {
      img: gcProj2,
      title: "Industrial Cluster Group Captive Project",
      desc: "An 8.5 MW group captive installation developed for a cluster of automotive and engineering units.",
      tags: ["INDORE", "INDUSTRIAL CLUSTER", "8.5 MW"],
    },
  ];

  return (
    <section className="gc-projects">
      <div className="gc-projects-header">
        <p className="gc-projects-tag">
          <span className="gc-projects-dot" />
          FEATURED PROJECTS
        </p>
        <h2 className="gc-projects-title">Shared Solar. Shared Success.</h2>
      </div>

      <div className="gc-projects-grid">
        {projects.map((p, i) => (
          <div className="gc-projects-card" key={i}>
            <div className="gc-projects-img-wrap">
              <img src={p.img} alt={p.title} className="gc-projects-card-img" loading="lazy" />
            </div>
            <div className="gc-projects-card-body">
              <h3 className="gc-projects-card-title">{p.title}</h3>
              <p className="gc-projects-card-desc">{p.desc}</p>
              <div className="gc-projects-tags">
                {p.tags.map((tag, j) => (
                  <span className="gc-projects-tag-pill" key={j}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
// /* ================================================
//    5. TESTIMONIALS
//    ================================================ */
// const Testimonials = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Anjali Verma",
//       role: "Property Owner, Bengaluru",
//       quote:
//         '"True Renewables made our solar installation simple and hassle-free. The team was professional throughout the process."',
//       photo: Testi1,
//     },
//     {
//       id: 2,
//       name: "Sandeep Reddy",
//       role: "Managing Director, Reddy Commercial Spaces",
//       quote:
//         '"The installation was smooth and the system is performing very well. A reliable team to work with."',
//       photo: Testi2,
//     },
//     {
//       id: 3,
//       name: "Harshvardhan Kulkarni",
//       role: "Director, Altura Industrial Solutions",
//       quote:
//         '"True Renewables delivered a dependable solar solution for our facility and helped reduce our energy costs."',

//       photo: Testi3,
//     },
//   ];

//   // ── TESTIMONIAL CARD ──
//   const TestimonialCard = ({ item, animClass }) => (
//     <div className={`testi-card ${animClass || ""}`}>
//       <div className="testi-card-content">
//         <div className="testi-person">
//           <div>
//             <p className="testi-name">{item.name}</p>
//             <p className="testi-role">{item.role}</p>
//           </div>
//         </div>
//         <hr className="testi-divider" />
//         <p className="testi-quote">{item.quote}</p>
//       </div>
//       <div className="testi-card-photo">
//         {item.photo ? (
//           <img src={item.photo} alt={item.name} className="testi-photo" />
//         ) : (
//           <div className="testi-photo-placeholder" />
//         )}
//       </div>
//     </div>
//   );

//   const ChevronLeft = () => (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="15 18 9 12 15 6" />
//     </svg>
//   );

//   const ChevronRight = () => (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="9 18 15 12 9 6" />
//     </svg>
//   );

//   const [current, setCurrent] = useState(0);
//   const [slideDir, setSlideDir] = useState("");
//   const [animKey, setAnimKey] = useState(0);
//   const headerRef = useReveal();
//   const total = testimonials.length;

//   const prev = () => {
//     setSlideDir("testi-slide-left");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c - 1 + total) % total);
//   };

//   const next = () => {
//     setSlideDir("testi-slide-right");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c + 1) % total);
//   };

//   return (
//     <section className="testi-section">
//       <div className="testi-header reveal-block" ref={headerRef}>
//         <div className="testi-header-left">
//           <p className="testi-tag">
//             <span className="testi-dot"></span> TESTIMONIALS
//           </p>
//           <h2 className="testi-title">
//             Trusted By Clients Across
//             <br />
//             Industries
//           </h2>
//         </div>
//         <div className="testi-header-right">
//           <p className="testi-subtitle">
//             Real experiences from clients who trust us
//             <br />
//             with their solar journey.
//           </p>
//           <div className="testi-arrows testi-arrows-header">
//             <button
//               className="testi-arrow"
//               onClick={prev}
//               aria-label="Previous testimonial"
//             >
//               <ChevronLeft />
//             </button>
//             <button
//               className="testi-arrow"
//               onClick={next}
//               aria-label="Next testimonial"
//             >
//               <ChevronRight />
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="testi-cards" key={animKey}>
//         <TestimonialCard
//           item={testimonials[current % total]}
//           animClass={slideDir}
//         />
//         <TestimonialCard
//           item={testimonials[(current + 1) % total]}
//           animClass={`${slideDir} testi-delay`}
//         />
//       </div>
//     </section>
//   );
// };

/* ================================================
   GROUP CAPTIVE PAGE
   ================================================ */
function GroupCaptive() {
  useEffect(() => {
    document.body.classList.add("captive-page");

    return () => {
      document.body.classList.remove("captive-page");
    };
  }, []);

  return (
    <div>
      <GroupCaptiveHero />
      <GroupCaptiveOverview />
      <GroupCaptiveSPV />
      <GroupCaptiveCompliance />
      <GroupCaptiveBenefits />
      <CaptiveWhoItsFor />
      <GroupCaptiveHowItWorks />
      <GroupCaptiveWhyChooseUs />
      <GroupCaptiveFeaturedProjects />
    </div>
  );
}

export default GroupCaptive;
